(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-uniform-builder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-pm-builder]').forEach((root) => {
    const requestedGender = new URLSearchParams(window.location.search).get('gender');
    let gender = requestedGender === 'men' ? 'men' : 'women';
    const tabs = [...root.querySelectorAll('[data-gender-tab]')];
    const groups = [...root.querySelectorAll('[data-group]')];
    const submit = root.querySelector('[data-builder-submit]');
    const status = root.querySelector('[data-builder-status]');
    const error = root.querySelector('[data-builder-error]');
    const topCount = root.querySelector('[data-top-count]');
    const pantCount = root.querySelector('[data-pant-count]');
    const topProgress = root.querySelector('[data-top-progress]');
    const pantProgress = root.querySelector('[data-pant-progress]');
    const party = root.querySelector('[data-builder-party]');
    let wasReady = false;
    let partyTimer;

    const triggerParty = () => {
      if (!party || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      window.clearTimeout(partyTimer);
      party.classList.remove('is-active');
      party.replaceChildren();

      const colors = ['#111111', '#CEFF9F', '#EC6135'];

      for (let index = 0; index < 42; index += 1) {
        const piece = document.createElement('span');
        const fromLeft = index % 2 === 0;
        const horizontal = 18 + Math.random() * 68;
        const vertical = 52 + Math.random() * 48;
        const rotation = (360 + Math.random() * 720) * (Math.random() > .5 ? 1 : -1);

        piece.className = 'pm-builder__party-piece';
        piece.style.left = fromLeft ? (1 + Math.random() * 5) + 'vw' : (94 + Math.random() * 5) + 'vw';
        piece.style.setProperty('--party-x', (fromLeft ? horizontal : -horizontal) + 'vw');
        piece.style.setProperty('--party-y', -vertical + 'vh');
        piece.style.setProperty('--party-rotate', rotation + 'deg');
        piece.style.setProperty('--party-delay', (Math.random() * .12) + 's');
        piece.style.setProperty('--party-color', colors[index % colors.length]);
        piece.style.width = (5 + Math.random() * 7) + 'px';
        piece.style.height = (8 + Math.random() * 10) + 'px';

        party.appendChild(piece);
      }

      void party.offsetWidth;
      party.classList.add('is-active');

      partyTimer = window.setTimeout(() => {
        party.classList.remove('is-active');
        party.replaceChildren();
      }, 1120);
    };

    const cards = () => [...root.querySelectorAll('[data-pm-card]')].filter((card) => card.dataset.gender === gender);
    const qty = (card) => Number(card.dataset.quantity || 0);

    const syncVariant = (card) => {
      const variants = JSON.parse(card.querySelector('[data-variants]').textContent);
      const first = variants[0];
      const wanted = [...first.options];
      card.querySelectorAll('[data-option-index]').forEach((select) => {
        wanted[Number(select.dataset.optionIndex)] = select.value;
      });
      const match = variants.find((variant) => variant.options.every((value, index) => value === wanted[index]));
      if (match) card.querySelector('[data-variant-id]').value = match.id;
    };

    const totals = () => cards().reduce((acc, card) => {
      acc[card.dataset.type] += qty(card);
      return acc;
    }, { top: 0, pant: 0 });

    const update = () => {
      const total = totals();
      topCount.textContent = total.top;
      pantCount.textContent = total.pant;
      topProgress.style.width = Math.min((total.top / 3) * 100, 100) + '%';
      pantProgress.style.width = Math.min((total.pant / 3) * 100, 100) + '%';
      topProgress.closest('.pm-builder__progress-item')?.classList.toggle('is-complete', total.top === 3);
      pantProgress.closest('.pm-builder__progress-item')?.classList.toggle('is-complete', total.pant === 3);
      const ready = total.top === 3 && total.pant === 3;
      submit.disabled = !ready;
      submit.classList.toggle('is-ready', ready);
      if (ready && !wasReady) {
        triggerParty();
      }
      wasReady = ready;

      status.textContent = ready ? 'Your 3 uniform sets are ready' : 'Select 3 tops and 3 pants to continue';
    };

    root.querySelectorAll('[data-pm-card]').forEach((card) => {
      syncVariant(card);
      card.querySelectorAll('[data-option-index]').forEach((select) => {
        select.addEventListener('change', () => syncVariant(card));
      });
      card.querySelector('[data-qty-minus]').addEventListener('click', () => {
        card.dataset.quantity = String(Math.max(0, qty(card) - 1));
        card.querySelector('[data-qty-output]').textContent = card.dataset.quantity;
        update();
      });
      card.querySelector('[data-qty-plus]').addEventListener('click', () => {
        const total = totals();
        if (total[card.dataset.type] >= 3) return;
        card.dataset.quantity = String(qty(card) + 1);
        card.querySelector('[data-qty-output]').textContent = card.dataset.quantity;
        update();
      });
    });

    tabs.forEach((tab) => tab.addEventListener('click', () => {
      gender = tab.dataset.genderTab;
      tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      groups.forEach((group) => group.hidden = group.dataset.group !== gender);
      update();
    }));

    const initialTab = tabs.find((tab) => tab.dataset.genderTab === gender);
    if (initialTab) {
      tabs.forEach((item) => {
        const active = item === initialTab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      groups.forEach((group) => group.hidden = group.dataset.group !== gender);
    }
    update();

    submit.addEventListener('click', async () => {
      const total = totals();
      if (total.top !== 3 || total.pant !== 3) return;

      const items = [];
      cards().forEach((card) => {
        const quantity = qty(card);
        if (quantity > 0) {
          items.push({
            id: Number(card.querySelector('[data-variant-id]').value),
            quantity
          });
        }
      });

      error.hidden = true;
      submit.disabled = true;
      submit.textContent = 'Adding your uniform...';

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items,
            sections: ['cart-drawer-section'],
            sections_url: window.location.pathname
          })
        });

        if (!response.ok) throw new Error('Unable to add uniform');

        const addData = await response.json();

        let drawerHtml = addData.sections?.['cart-drawer-section'];

        if (!drawerHtml) {
          const sectionResponse = await fetch(
            window.location.pathname + '?sections=cart-drawer-section',
            { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
          );
          if (sectionResponse.ok) {
            const sections = await sectionResponse.json();
            drawerHtml = sections['cart-drawer-section'];
          }
        }

        if (drawerHtml) {
          const parsed = new DOMParser().parseFromString(drawerHtml, 'text/html');
          const nextDrawerSection = parsed.getElementById('shopify-section-cart-drawer-section');
          const currentDrawerSection = document.getElementById('shopify-section-cart-drawer-section');

          if (nextDrawerSection && currentDrawerSection) {
            currentDrawerSection.replaceWith(nextDrawerSection);
          }
        }

        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
        const cartData = cartResponse.ok ? await cartResponse.json() : null;

        if (cartData) {
          document.querySelector('cart-icon')?.renderCartBubble?.(cartData.item_count, true);
        }

        await customElements.whenDefined('theme-drawer');
        await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

        const cartDrawer = document.querySelector('#cart-drawer');
        if (!cartDrawer?.open) throw new Error('Cart drawer unavailable');

        cartDrawer.open();
        submit.disabled = false;
        submit.textContent = 'Add uniform to cart';
      } catch (e) {
        error.hidden = false;
        submit.disabled = false;
        submit.textContent = 'Add uniform to cart';
      }
    });

  });
});

  } catch(e) { console.error(e); }
})();
})();
